import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setActiveFilterPage } from "../../store/actions/FilterActions";

/**
 * Isolates Redux list filters per page so filters on Members
 * do not leak into User Management (and vice versa).
 */
export default function useFilterPage(pageKey) {
  const dispatch = useDispatch();
  const activePage = useSelector((state) => state.filter.activePage);

  useEffect(() => {
    if (pageKey) {
      dispatch(setActiveFilterPage(pageKey));
    }
  }, [dispatch, pageKey]);

  return activePage === pageKey;
}
